// Przestrzeń nazw 'documents': baza wiedzy (lista dokumentów, tworzenie, szczegóły).
export default {
  header: {
    // Tekst z mockupu (sekcja „Materiały w bazie wiedzy").
    title: 'Materiały w bazie wiedzy',
    // VERIFY: brak w mockupie. Tam jest „Nowy folder" i wgrywanie plików, a u nas ręcznie
    // wklejany dokument.
    newDocument: 'Nowy dokument',
    // VERIFY: brak w mockupie, filtr typu dokumentu.
    typePlaceholder: 'Typ',
  },
  // VERIFY: brak w mockupie, wartości enuma `type` z API (`profile`, `waitlist`, `other`).
  types: {
    profile: 'Profil',
    waitlist: 'Lista oczekujących',
    other: 'Inne',
  },
  // VERIFY: cały blok, mockup pokazuje foldery z plikami, a nie tabelę dokumentów.
  table: {
    columns: {
      document: 'Dokument',
      content: 'Treść',
      id: 'ID',
      phoneNumber: 'Numer telefonu',
      company: 'Firma',
      created: 'Utworzono',
      updated: 'Zaktualizowano',
    },
  },
  // VERIFY: cały blok, brak w mockupie (formularz ręcznego dodania dokumentu).
  create: {
    company: 'Firma',
    name: 'Nazwa',
    namePlaceholder: 'Nazwa dokumentu',
    content: 'Treść',
    contentPlaceholder: 'Treść dokumentu',
  },
  // VERIFY: cały blok, brak w mockupie (ekran szczegółów dokumentu).
  details: {
    // „Baza wiedzy" z mockupu, reszta własna.
    backToList: 'Wróć do bazy wiedzy',
    company: 'Firma',
    userId: 'ID użytkownika',
    phoneNumber: 'Numer telefonu',
    lastModified: 'Ostatnia modyfikacja',
    dateCreated: 'Data utworzenia',
    nameLabel: 'Nazwa dokumentu',
    contentLabel: 'Treść dokumentu',
    nameRequired: 'Podaj nazwę',
  },
  // VERIFY: cały blok, powiadomienia po zapisie dokumentu, brak w mockupie.
  notifications: {
    created: 'Dokument został utworzony.',
    updated: 'Dokument został zaktualizowany.',
    error: 'Coś poszło nie tak. Spróbuj ponownie.',
  },
} as const;
